<template>
  <div class="financial">
    <div class="base-search">
      <el-input
        placeholder="请输入内容"
        v-model="searchValue"
        class="input-with-select"
        @keyup.enter.native="search"
        clearable
        @clear="search"
        style="width: 220px;"
      >
        <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
      </el-input>
      <label style="margin-left: 20px;">是否反馈</label>
      <el-select
        v-model="feedbackStatus"
        clearable
        placeholder="请选择是否反馈"
        @change="search"
        style="width: 200px;margin-left: 10px;"
      >
        <el-option
          v-for="item in feedbackStatusOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <label style="margin-left: 20px;">是否过期</label>
      <el-select
        v-model="expiredStatus"
        clearable
        placeholder="请选择是否过期"
        @change="search"
        style="width: 200px;margin-left: 10px;"
      >
        <el-option
          v-for="item in expiredStatusOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <label style="margin-left: 20px;">是否标注</label>
      <el-select
        v-model="markStatus"
        clearable
        placeholder="请选择是否标注"
        @change="search"
        style="width: 200px;margin-left: 10px;"
      >
        <el-option
          v-for="item in markStatusOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </div>
    <div class="base-table">
      <el-table
        ref="multipleTable"
        :data="tableData"
        style="width: 100%"
        :header-cell-style="{ background: '#E5F3FE', color: '#623AA2' }"
        class="table"
      >
        <el-table-column type="index" width="150" label="序号" align="center">
          <template slot-scope="scope">
            <span>{{ scope.$index + (current_page - 1) * per_page + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="企业名称"
          align="center"
          prop="enterprisesHistoryName"
        ></el-table-column>
        <el-table-column
          label="拟融资金额(万元)"
          align="center"
          prop="intendedFinancingAmount"
        ></el-table-column>
        <el-table-column label="融资期限" align="center" prop="financingTermName"></el-table-column>
        <el-table-column label="融资用途" align="center" prop="financingPurpose"></el-table-column>
        <el-table-column
          label="可提供担保方式"
          align="center"
          prop="guaranteeTypeName"
        ></el-table-column>
        <el-table-column label="审核状态" align="center">
          <template slot-scope="scope">
            <span>{{ getServicesApprovalStatus(scope.row.servicesApprovalStatus) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="是否过期" align="center" prop="expiredStatus">
          <template slot-scope="scope">
            <span>{{ scope.row.expiredStatus ? '已过期' : '未过期' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="担保状态" align="center">
          <template slot-scope="scope">
            <!--<span>{{ getGuaranteeStatus(scope.row.guaranteeStatus) }}</span>-->
            <span>{{ scope.row.guaranteeInstitutionState === 0 ? '无需担保' : '未担保' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="是否反馈" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.feedbackStatus ? '已反馈' : '未反馈' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="意向机构"
          align="center"
          prop="investmentFirmsName"
        ></el-table-column>
        <el-table-column label="机构审核状态" align="center">
          <template slot-scope="scope">
            <span>{{ getInstitutionsApprovalStatus(scope.row.institutionsApprovalStatus) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="是否标注" align="center" prop="markStatus">
          <template slot-scope="scope">
            <span>{{ scope.row.markStatus ? '已标注' : '未标注' }}</span>
          </template>
        </el-table-column>
        <el-table-column width="200px" align="center" label="操作">
          <template slot-scope="scope">
            <el-button class="mini_btn" type="text" @click="handleDetail(scope.row)">
              编辑
            </el-button>
            <template
              v-if="
                scope.row.institutionsApprovalStatus === 4 && scope.row.servicesApprovalStatus === 4
              "
            >
              <el-button class="mini_btn" type="text" @click="handleCheck(scope.row, 5)">
                立项
              </el-button>
              <el-button class="mini_btn" type="text" @click="handleCheck(scope.row, 6)">
                不立项
              </el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page.sync="current_page"
      :page-size="per_page"
      layout="total,prev, pager, next"
      :total="total"
      style="text-align:left;margin:20px 0"
    ></el-pagination>
    <el-dialog
      @closed="is_submit = true"
      :title="Title"
      center
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      :append-to-body="true"
    >
      <p class="form-title" style="margin-top: 0;">融资需求</p>
      <el-form
        class="form"
        :model="ruleForm"
        ref="form"
        label-width="120px"
        :rules="rules"
        label-position="right"
      >
        <el-form-item label="融资方式">
          <el-select
            v-model="ruleForm.financingType"
            placeholder="请选择融资方式"
            clearable
            disabled
          >
            <el-option key="1" label="债权融资" :value="1"></el-option>
            <el-option key="2" label="股权融资" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="企业名称">
          <el-input
            placeholder="企业名称"
            v-model="ruleForm.enterprisesHistoryName"
            clearable
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="ruleForm.financingType === 1 ? '意向金融机构' : '意向投资机构'"
          prop="investmentFirmsIds"
        >
          <!--          <el-input-->
          <!--            :placeholder="ruleForm.financingType === 1 ? '意向金融机构' : '意向投资机构'"-->
          <!--            v-model="ruleForm.investmentFirmsName"-->
          <!--            clearable-->
          <!--          ></el-input>-->
          <el-select
            multiple
            v-model="ruleForm.investmentFirmsIds"
            placeholder="请选择"
            style="width: 100%"
            clearable
            filterable
            :disabled="disabled"
            @change="
              selectChange(
                $event,
                ruleForm.financingType === 1 ? financeList : warrantList,
                'investmentFirmsIds',
                'orgName'
              )
            "
          >
            <el-option
              v-for="item in ruleForm.financingType === 1 ? financeList : warrantList"
              :key="item.id"
              :label="item.orgName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="ruleForm.financingType === 2" label="拟出让股权(%)">
          <el-input
            placeholder="请输入拟出让股权"
            v-model="ruleForm.imitateSellEquity"
            clearable
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="拟融资金额(万元)">
          <el-input
            placeholder="请输入拟融资金额"
            v-model="ruleForm.intendedFinancingAmount"
            clearable
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="融资用途">
          <el-input
            placeholder="请输入融资用途"
            v-model="ruleForm.financingPurpose"
            clearable
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item v-if="ruleForm.financingType === 1" label="融资期限">
          <el-input
            placeholder="融资期限"
            v-model="ruleForm.financingTermName"
            clearable
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item v-if="ruleForm.financingType === 1" label="可提供担保方式">
          <el-input
            placeholder="可提供担保方式"
            v-model="ruleForm.guaranteeTypeName"
            clearable
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item v-if="ruleForm.financingType === 1" label="担保机构">
          <div style="text-align: left;">
            <el-radio v-model="ruleForm.guaranteeInstitutionState" :label="0" disabled>
              不需要
            </el-radio>
            <el-radio v-model="ruleForm.guaranteeInstitutionState" :label="1" disabled>
              需要
            </el-radio>
          </div>
          <el-input
            v-if="ruleForm.guaranteeInstitutionState"
            placeholder="担保机构"
            v-model="ruleForm.guaranteeInstitutionName"
            clearable
            disabled
          ></el-input>
        </el-form-item>
      </el-form>
      <p class="form-title">企业信息</p>
      <company-detail :dataList="ruleForm" :disabled="true"></company-detail>
      <p class="form-title">
        反馈记录
        <el-button :disabled="disabled" type="text" @click="feedback" style="margin-left: 10px;">
          +添加反馈
        </el-button>
      </p>
      <div class="base-table">
        <el-table
          ref="recordTable"
          :data="tableRecords"
          border
          style="width: 100%"
          :header-cell-style="{ background: '#E5F3FE', color: '#623AA2' }"
          class="table"
        >
          <el-table-column type="index" width="150" label="序号" align="center">
            <template slot-scope="scope">
              <span>{{ scope.$index + (current_page - 1) * per_page + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column label="留言" align="center" prop="content"></el-table-column>
          <el-table-column label="反馈时间" align="center" prop="createTime"></el-table-column>
        </el-table>
        <p class="form-title">审核信息</p>
        <el-form
          class="form"
          :model="ruleForm"
          ref="form"
          label-width="120px"
          :rules="rules"
          label-position="right"
          :disabled="disabled"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="审核状态">
                <el-select
                  v-model="ruleForm.servicesApprovalStatus"
                  placeholder="请选择审核状态"
                  clearable
                >
                  <el-option
                    v-for="item in approvalStatusOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    :disabled="item.disabled"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="审核意见">
                <el-input
                  placeholder="请输入审核意见"
                  v-model="ruleForm.auditOpinion"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="附件上传">
            <el-upload
              class="upload-demo"
              :action="this.uploadURL"
              name="file"
              :file-list="fileList"
              :show-file-list="true"
              :on-remove="onRemove"
              :on-success="handlePictureCardPreview"
              :on-preview="onPreview"
              accept=".png, .jpg, .jpeg, .pdf, .doc, .docx"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
        </el-form>
        <p class="form-title" v-if="ruleForm.servicesApprovalStatus === 4">标注信息</p>
        <el-form
          class="form"
          v-if="ruleForm.servicesApprovalStatus === 4"
          :model="ruleForm"
          ref="form"
          label-width="120px"
          :rules="rules"
          label-position="right"
          :disabled="disabled"
        >
          <el-row v-if="ruleForm.financingType === 1">
            <el-col :span="12">
              <el-form-item label="产品类型">
                <el-select
                  v-model="ruleForm.markProductTypeId"
                  placeholder="请选择产品类型"
                  clearable
                  @change="selectChange($event, productTypeOptions, 'markProductTypeName')"
                >
                  <el-option
                    v-for="item in productTypeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="融资金额（万元）">
                <el-input
                  placeholder="请输入融资金额"
                  v-model="ruleForm.markFinancingAmount"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="担保类型">
                <el-select
                  v-model="ruleForm.markGuaranteeTypeId"
                  placeholder="请选择担保类型"
                  clearable
                  @change="
                    selectChange($event, markGuaranteeTypeIdOptions, 'markGuaranteeTypeName')
                  "
                >
                  <el-option
                    v-for="item in markGuaranteeTypeIdOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="parseInt(item.value)"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="ruleForm.financingType === 2">
            <el-col :span="12">
              <el-form-item label="投资金额（万元）">
                <el-input
                  placeholder="请输入投资金额"
                  v-model="ruleForm.investmentAmount"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="股权占比（%）">
                <el-input
                  placeholder="请输入股权占比"
                  v-model="ruleForm.equityRatio"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeForm()">取 消</el-button>
        <el-button type="primary" v-if="!disabled" @click="submitForm()">确 定</el-button>
      </div>
    </el-dialog>
    <!-- <el-dialog
      title="审批内容"
      center
      :visible.sync="dialogCheckVisible"
      :close-on-click-modal="false"
      :append-to-body="true"
    >
      <el-form
        label-position="right"
        ref="form"
        size="small"
        :model="ruleForm"
        :rules="rules"
        label-width="120px"
      >
        <el-form-item label="审核意见" prop="introduction">
          <el-input
            type="textarea"
            :autosize="{ minRows: 4 }"
            placeholder="请输入审核意见"
            v-model="ruleForm.introduction"
          ></el-input>
        </el-form-item>
        <el-form-item label="附件">
          <el-upload
            class="upload-demo"
            :action="this.uploadURL"
            name="file"
            :file-list="fileList"
            :show-file-list="true"
            :on-remove="onRemove"
            :on-success="handlePictureCardPreview"
            :on-preview="onPreview"
            accept=".png, .jpg, .jpeg, .pdf, .doc, .docx"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeForm()">取 消</el-button>
        <el-button type="primary" @click="submitForm()">确 定</el-button>
      </div>
    </el-dialog> -->
    <el-dialog
      title="反馈意见"
      center
      :visible.sync="dialogFeedbackVisible"
      :close-on-click-modal="false"
      :append-to-body="true"
    >
      <el-input
        type="textarea"
        :autosize="{ minRows: 10 }"
        placeholder="请输入反馈意见"
        v-model="recordContent"
      ></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeFeedback()">取 消</el-button>
        <el-button type="primary" @click="submitFeedback()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import { FunDownload } from "@/utils/tool";
import CompanyDetail from './companyDetail.vue';

export default {
	components: {
    CompanyDetail
	},
	data() {
		return {
      financeList: [],
      warrantList: [],
			is_submit: true,
			total: 10,
			per_page: 10,
			current_page: 1,
			Title: "",
			searchValue: null,
      feedbackStatus: null,
      expiredStatus: null,
      markStatus: null,
			dialogFormVisible: false,

			fileList: [],
			tableData: [],
      tableRecords: [],
			feedbackStatusOptions: [{
					value: 1,
					label: "已反馈",
				},
				{
					value: 0,
					label: "未反馈",
				}
			],
      expiredStatusOptions: [{
					value: 1,
					label: "已过期",
				},
				{
					value: 0,
					label: "未过期",
				}
      ],
      markStatusOptions: [{
					value: 1,
					label: "已标注",
				},
				{
					value: 0,
					label: "未标注",
				}
      ],
			approvalStatusOptions: [{
					value: 1,
					label: "待审核",
				},
				{
					value: 2,
					label: "不通过",
				},
				{
					value: 3,
					label: "退回",
				},
				{
					value: 4,
					label: "通过",
				},
				{
					value: 5,
					label: "已立项",
          disabled: true
				},
				{
					value: 6,
					label: "不立项",
          disabled: true
				},
				// {
				// 	value: 5,
				// 	label: "未担保",
				// },
				// {
				// 	value: 6,
				// 	label: "拒绝担保",
				// },
				// {
				// 	value: 7,
				// 	label: "已担保",
				// }
			],
      markGuaranteeTypeIdOptions: [],
      productTypeOptions: [
        { value: '1', label: "银行贷款" },
        { value: '2', label: "银行短期融资" },
        { value: '3', label: "企业债券" },
        { value: '4', label: "金融租赁" },
      ],

			ruleForm: {
        investmentFirmsIds:[],
      },
      rules: {
        image: [{ required: true, trigger: 'blur', message: '请上传头像' }],
        investmentFirmsIds: [{ required: true, trigger: 'blur', message: '请选择意向机构' }],

      },
      // dialogCheckVisible: false,
      dialogFeedbackVisible: false,
      recordContent: null, // 反馈意见
      disabled: false
		};
	},
	created() {
    this.getGroup();
		this.search();
    this.getfinanceList(1, 'warrantList')
    this.getfinanceList(2, 'financeList')
	},
	methods: {
    // 获取意向金融机构
    getfinanceList(type, prop) {
      let obj = {
        page: 1,
        pageSize: 1000,
        dataType: type
      }
      if(prop === 'financeList') {
        // obj.orgType = this.financialInstitutionCategory.find(item => item.label === '银行').id
      }
      this.http.post(`${urlConfig.devUrl}apij2/admin-api/finance/investment-firms/getList`, obj).then(
          (response) => {
            if (response.code == 0) {
              console.log('response', response)
              this[prop] = response.data
            } else {
              this.$message.error(response.status);
            }
          },
          (error) => {}
      )

    },
    // selectChange(e, list, props) {
    //   console.log(e,list,props)
    //   if (e) {
    //     this.ruleForm[props] = list.find(item => item.value === e).label;
    //   } else {
    //     this.ruleForm[props] = '';
    //   }
    //   console.log('this.ruleForm[props]', this.ruleForm[props]);
    // },
    selectChange(e, list, props) {
      console.log(e,'e',list,'lise',props,'props')
      if (e.length > 0) {
        if(Array.isArray(e)){
          console.log('e是数组')
          this.ruleForm[props] = []
          e.forEach(items=>{
            if(list.find(item => item.id === items)?.id){
              this.ruleForm[props].push(list.find(item => item.id === items)?.id)
            }
          })
        }else {
          this.ruleForm[props] = list.find(item => item.value == e || item.id == e)?.label
          console.log(this.ruleForm[props],'this.ruleForm[props]')
        }
        this.$forceUpdate()
      } else {
        this.ruleForm[props] = [];
        this.$forceUpdate()
      }
    },
    getServicesApprovalStatus(status) {
      switch (status) {
				case 1:
					return '待审核'
				case 2:
					return '不通过'
				case 3:
					return '退回'
				case 4:
					return '通过'
				case 5:
					return '已立项'
				case 6:
					return '不立项'
			}
    },
    getGuaranteeStatus(status) {
      switch (status) {
				case 5:
					return '未担保'
				case 6:
					return '拒绝担保'
				case 7:
          return '已担保'
        case 8:
          return '无需担保'
			}
    },
    getInstitutionsApprovalStatus(status) {
      switch (status) {
				case 1:
					return '待审核'
				case 2:
					return '不通过'
				case 3:
					return '退回'
				case 4:
					return '通过'
			}
    },
    feedback(){
      this.dialogFeedbackVisible = true
    },
    closeFeedback() {
      this.dialogFeedbackVisible = false
    },
    submitFeedback() {
      this.http.post(`${this.urlConfig.devUrl}apij2/admin-api/finance/feedback-record/create`,
          {needsApplyId: this.ruleForm.id, content: this.recordContent}).then((res) => {
				if (res.code == 0) {
          this.$message({
            type: "success",
            message: "反馈意见成功",
          });
					this.dialogFeedbackVisible = false;
          this.getRecord({needsApplyId: this.ruleForm.id});
				}
			});

    },
		getData(item) {
			const params = {
				page: this.current_page,
				pageSize: this.per_page,
				...item,
			}
			this.http.post(`${this.urlConfig.devUrl}apij2/admin-api/finance/needs-apply/approval/page`, params)
          .then((res) => {
				if (res.code == 0) {
					this.tableData = res.data.data;
					this.total = res.data.total;
					this.per_page = res.data.per_page;
					this.current_page = res.data.current_page * 1;
				}
			});
		},
    getGroup() {
      this.http
        .post(`${this.urlConfig.devUrl}apij2/admin-api/system/dict-data/getGroup`, {
          dictTypes: ['corporate_financing_protection_method']
        })
        .then(res => {
          if (res.code === 0) {
            const { corporate_financing_protection_method } = res.data;
            this.markGuaranteeTypeIdOptions = [...corporate_financing_protection_method];
          }
        });
    },
		//搜索
		search() {
			this.getData({
        page: 1,
        keyword: this.searchValue,
        feedbackStatus: this.feedbackStatus,
        expiredStatus: this.expiredStatus,
        markStatus: this.markStatus
      });
		},
		//选择
		selectionChange(selection) {
			this.deleteRow = "";
			if (selection.length != 0) {
				let arr = [];
				selection.forEach((item) => {
					arr.push(item.id);
				});
				this.deleteRow = arr.join(",");
			}
		},
		//编辑
		handleDetail(row) {
      this.disabled = row.servicesApprovalStatus >= 2 || row.expiredStatus === 1;
      this.http.get(`${this.urlConfig.devUrl}apij2/admin-api/finance/needs-apply/getDetail?id=${row.id}`)
        .then((res) => {
          if (res.code == 0) {
            const data = res.data;
            this.ruleForm = data;
            this.ruleForm.area = data.area ? JSON.parse(data.area) : null
						this.ruleForm.industry = data.industry ? JSON.parse(data.industry) : null
						this.ruleForm.registeredAddress = data.registeredAddress ? JSON.parse(data.registeredAddress) : null
						this.ruleForm.physicalAddress = data.physicalAddress ? JSON.parse(data.physicalAddress) : null
            this.ruleForm.markGuaranteeTypeId = data.markGuaranteeTypeId
            this.ruleForm.approvalStatus = data.servicesApprovalStatus
            this.ruleForm.investmentFirmsIds = data.investmentFirmsId ? [data.investmentFirmsId] : []
            this.fileList = data.fileList ? JSON.parse(data.fileList) : []
						this.dialogFormVisible = true;
						this.Title = "详情";
            this.getRecord({needsApplyId: row.id});
          } else {
            this.$message({
              message: "失败！",
              type: "error",
            });
          }
        });
		},
    getRecord(item){
      const params = {
				is_page: 1,
				...item,
			}
      this.http.post(`${this.urlConfig.devUrl}apij2/admin-api/finance/feedback-record/page`, params).then((res) => {
				if (res.code == 0) {
					this.tableRecords = res.data.data;
				}
			});
    },
    // 审核
    handleCheck(item, type) {
      // this.dialogCheckVisible = true
      this.http.post(`${this.urlConfig.devUrl}apij2/admin-api/finance/needs-apply/projectApproval`, {id: item.id, servicesApprovalStatus: type}).then((res) => {
        if (res.code == 0) {
          this.$message({
            type: "success",
            message: "状态修改成功",
          });
          this.search();
        }
      });
    },

		//翻页
		handleCurrentChange(e) {
			this.getData({
        page: e,
        keyword: this.searchValue,
        feedbackStatus: this.feedbackStatus,
        expiredStatus: this.expiredStatus,
        markStatus: this.markStatus
      });
		},
		//取消
		closeForm() {
			this.dialogFormVisible = false;
		},
		//提交
		submitForm() {
      /**
       * @markProductTypeName 产品类型
       * @markGuaranteeTypeName 担保类型
       * @markFinancingAmount 融资金额  类型为债券融资才有
       * @investmentAmount 投资金融
       * @equityRatio 股权占比 类型为股权融资才有
       * 股权融资包含 投资金额，股权占比
       * 债券融资包含  产品类型，融资金额，担保类型
       * 先判断用户有没有填写标注信息，填写 markStatus = 1
       * 两个下拉筛选，如果用户已经填写，给个toString方法
       * */
      console.log(this.ruleForm.markProductTypeName,'this.ruleForm.markProductTypeName')

      // this.ruleForm.investmentFirmsIds = JSON.stringify(this.ruleForm.investmentFirmsIds)
      if(this.ruleForm?.markProductTypeName?.length > 0 || this.ruleForm?.markGuaranteeTypeName?.length>0 ||
          this.ruleForm?.investmentAmount?.length > 0 || this.ruleForm?.equityRatio?.length > 0){
        this.ruleForm.markStatus = 1
        // 如果markGuaranteeTypeName有值，toString
        if(this.ruleForm?.markGuaranteeTypeName){
          this.ruleForm.markGuaranteeTypeName = this.ruleForm.markGuaranteeTypeName.toString()
        }
        // 如果markProductTypeName有值，toString
        if(this.ruleForm?.markProductTypeName){
          this.ruleForm.markProductTypeName = this.ruleForm.markProductTypeName.toString()
        }
      }
			const params = {
        ...this.ruleForm,
        needsApplyId: this.ruleForm.id,
        // fileList: this.fileList.length > 0 ? JSON.stringify(this.fileList) : "",
        fileList: JSON.stringify(this.fileList),
        approvalStatus: this.ruleForm.servicesApprovalStatus,
      }
      this.http.post(`${this.urlConfig.devUrl}apij2/admin-api/finance/needs-apply-record/approval`, params).then((res) => {
				if (res.code == 0) {
					this.$message({
            type: "success",
            message: "修改成功",
          });
          this.dialogFormVisible = false;
          this.search();
				}
			});
		},
		onRemove(file, fileList) {
      this.fileList = this.getList(fileList);
    },
    handlePictureCardPreview(response, file, fileList) {
      this.fileList = this.getList(fileList);
    },
    onPreview(file) {
      FunDownload(this.imgUrl + file.url, file.name);
    },
    getList(fileList) {
      return fileList.map((el) => {
        return {
          name: el.name,
          url: el?.url || el?.response?.data.store_result,
          uid: el.uid,
        };
      });
    },
	},
};
</script>

<style scoped lang="scss">
.financial {
  height: 100%;
  width: 100%;

  .base-search {
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .base-table {
    width: 100%;
    margin-top: 20px;
    border: 1px solid #eef1f6;
  }
}
/deep/ .upload-demo {
  border: 1px solid #ffffff !important;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.form {
  /deep/ {
    .el-input,
    .el-select,
    .el-date-editor {
      width: 100%;
    }
  }
  &-title {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: bold;
  }
}
</style>
